/*
 * � 2020 Microsoft. All rights reserved.
 */

define('Solitaire/SolitaireStatistics',[
        'lodash',
        'absolute/textutils',
        'util/StringComparison',
        'Managers/StatManager',
        'Solitaire/SolitaireGameMode',
        'Solitaire/GameState',
        'SolitaireShared/CardLogic/IDailyAuthority'
    ],
    function (_, TextUtils, StringComparison, StatManager, SolitaireGameMode, GameState, IDailyAuthority) {
        "use strict";


        var SolitaireStatistics = function () {

            this.initSolitaireStatistics();
        };

        SolitaireStatistics.prototype.initSolitaireStatistics = function () {
            this.InitStatKeys();
            this.InitGameStats();
        };

        SolitaireStatistics.StatKey = function (gameMode, key) {
            this.initStatKey(gameMode, key);
        };

        SolitaireStatistics.StatKey.prototype.initStatKey = function (gameMode, key) {
            this.GameMode = gameMode;
            this.Key = key;
        };


        //private Dictionary<SolitaireGameMode, IEnumerable<StatKey>> _statKeys;

        //private Dictionary<StatKey, IEnumerable<Func<StatKey, string>>> _gameStats;

        //#region Constants

        SolitaireStatistics.GAMESPLAYEDTOTAL = "TotalGamesPlayed";
        SolitaireStatistics.GAMESPLAYEDSUFFIX = "GamesPlayed";
        SolitaireStatistics.GAMESWONTOTAL = "TotalGamesWon";
        SolitaireStatistics.GAMESWONSUFFIX = "GamesWon";
        SolitaireStatistics.GAMESLOSTSUFFIX = "GamesLost";
        SolitaireStatistics.BOARDSCLEARED = "BoardsCleared";
        SolitaireStatistics.HIGHESTBOARDSCLEARED = "HighestBoardsCleared";
        SolitaireStatistics.STACKSMADE = "StacksMade";
        SolitaireStatistics.MATCHES = "Matches";
        SolitaireStatistics.HIGHESTMATCHES = "HighestMatches";
        SolitaireStatistics.WINNINGSTREAK = "Streak";
        SolitaireStatistics.LONGESTLOSINGSTREAK = "LongestLosingStreak";
        SolitaireStatistics.LONGESTWINNINGSTREAK = "LongestWinningStreak";
        SolitaireStatistics.LOSINGSTREAK = "LosingStreak";
        SolitaireStatistics.WINPERCENTAGE = "WinPercentage";
        SolitaireStatistics.HIGHSCORE = "HighScore";
        SolitaireStatistics.ROWSCLEARED = "RowsCleared";
        SolitaireStatistics.HIGHESTROWSCLEARED = "HighestRowsCleared";
        SolitaireStatistics.CARDSCHAINED = "CardsChained";
        SolitaireStatistics.HIGHESTCARDSCHAINED = "HighestCardsChained";
        SolitaireStatistics.GAMEBESTTIME = "BestTime";
        SolitaireStatistics.GAMETIME = "TotalTime";
        SolitaireStatistics.TOTALSCORE = "TotalScore";
        SolitaireStatistics.CARDSFLIPPED = "TotalCardsFlipped";
        SolitaireStatistics.BOARDWONWITHKING = "BoardWonWithKing";
        SolitaireStatistics.GAMESWONINAROW = "GamesWonInARow";
        SolitaireStatistics.PEAKSCLEARED = "PeaksCleared";
        SolitaireStatistics.HIGHESTPEAKSCLEARED = "HighestPeaksCleared";
        SolitaireStatistics.TOTALWON_AWARD = "TotalWon_Award";
        SolitaireStatistics.TOTALBOARDSCLEAR_AWARD = "TotalBoardsClear_Award";

        SolitaireStatistics.GAMESPLAYEDSINCELASTADSHOWING = "GamesPlayedSinceLastAdShowing";
        SolitaireStatistics.NEXTADSHOWINGPERIOD = "NextAdShowingPeriod";
        SolitaireStatistics.LASTSAVEDATE = "LastSaveDate";
        SolitaireStatistics.GlobalStreak = "GlobalStreak";

       // var GamesNames = ["Spider", "FreeCell", "Pyramid", "TriPeaks", "Klondike"];

        //#endregion

        var current = null;

        Object.defineProperty(SolitaireStatistics, "Current", {
            get: function () {
                if (!current) {
                    current = new SolitaireStatistics();
                }
                return current;
            }
        });

        SolitaireStatistics.prototype.InitStatKeys = function () {
            this._statKeys = {};

            var klondikeKeys = [
                new SolitaireStatistics.StatKey((SolitaireGameMode.Klondike), "1STANDARDKLONDIKE"),
                new SolitaireStatistics.StatKey((SolitaireGameMode.Klondike), "1LASVEGASKLONDIKE"),
                new SolitaireStatistics.StatKey((SolitaireGameMode.Klondike), "1LASVEGASCUMULATIVEKLONDIKE"),
                new SolitaireStatistics.StatKey((SolitaireGameMode.Klondike), "3STANDARDKLONDIKE"),
                new SolitaireStatistics.StatKey((SolitaireGameMode.Klondike), "3LASVEGASKLONDIKE"),
                new SolitaireStatistics.StatKey((SolitaireGameMode.Klondike), "3LASVEGASCUMULATIVEKLONDIKE")
            ];

            var spiderKeys = [
                new SolitaireStatistics.StatKey((SolitaireGameMode.Spider), "1SPIDER"),
                new SolitaireStatistics.StatKey((SolitaireGameMode.Spider), "2SPIDER"),
                new SolitaireStatistics.StatKey((SolitaireGameMode.Spider), "4SPIDER")

            ];

            var freeCellKeys = [
                new SolitaireStatistics.StatKey((SolitaireGameMode.FreeCell), "FREECELL")
            ];

            var pyramidKeys = [
                new SolitaireStatistics.StatKey((SolitaireGameMode.Pyramid), "PYRAMID"),
                new SolitaireStatistics.StatKey((SolitaireGameMode.Pyramid), "TIMEDPYRAMID")
            ];

            var tripeaksKeys = [
                new SolitaireStatistics.StatKey((SolitaireGameMode.TriPeaks), "TRIPEAKS")
            ];

            this._statKeys[SolitaireGameMode.getModeById(SolitaireGameMode.Klondike)] = klondikeKeys;
            this._statKeys[SolitaireGameMode.getModeById(SolitaireGameMode.Spider)] = spiderKeys;
            this._statKeys[SolitaireGameMode.getModeById(SolitaireGameMode.FreeCell)] = freeCellKeys;
            this._statKeys[SolitaireGameMode.getModeById(SolitaireGameMode.Pyramid)] = pyramidKeys;
            this._statKeys[SolitaireGameMode.getModeById(SolitaireGameMode.TriPeaks)] = tripeaksKeys;
        };

        SolitaireStatistics.prototype.InitGameStats = function () {
            var klondike =
                [
                    this.GetGamesPlayedFormatString.bind(this),
                    this.GetGamesWonFormatString.bind(this),
                    this.GetGamesLostFormatString.bind(this),
                    this.GetPercentWon.bind(this),
                    this.GetWinningStreakFormatString.bind(this),
                    this.GetLongestWinningStreakFormatString.bind(this),
                    this.GetLongestLosingStreakFormatString.bind(this),
                    this.GetHighScoreFormatString.bind(this),
                    this.GetAverageScoreFormatString.bind(this),
                    this.GetBestTimeFormatString.bind(this),
                    this.GetAverageTimeFormatString.bind(this)
                ];

            var spider =
                [
                    this.GetGamesPlayedFormatString.bind(this),
                    this.GetGamesWonFormatString.bind(this),
                    this.GetGamesLostFormatString.bind(this),
                    this.GetPercentWon.bind(this),
                    this.GetHighScoreFormatString.bind(this),
                    this.GetAverageScoreFormatString.bind(this),
                    this.GetBestTimeFormatString.bind(this),
                    this.GetAverageTimeFormatString.bind(this),
                    this.GetStacksFormatString.bind(this),
                    this.GetAverageStacksFormatString.bind(this)
                ];

            var freecell =
                [
                    this.GetGamesPlayedFormatString.bind(this),
                    this.GetGamesWonFormatString.bind(this),
                    this.GetGamesLostFormatString.bind(this),
                    this.GetPercentWon.bind(this),
                    this.GetBestTimeFormatString.bind(this),
                    this.GetAverageTimeFormatString.bind(this)
                ];

            var pyramid =
                [
                    this.GetGamesPlayedFormatString.bind(this),
                    this.GetHighScoreFormatString.bind(this),
                    this.GetHighestBoardsFormatString.bind(this),
                    this.GetBoardsFormatString.bind(this),
                    this.GetAverageBoardsFormatString.bind(this),
                    this.GetHighestRowsClearedFormatString.bind(this),
                    this.GetRowsClearedFormatString.bind(this),
                    this.GetAverageRowsClearedFormatString.bind(this),
                    this.GetHighestMatchesFormatString.bind(this),
                    this.GetMatchesFormatString.bind(this),
                    this.GetAverageMatchesFormatString.bind(this)
                ];

            var tripeaks =
                [
                    this.GetGamesPlayedFormatString.bind(this),
                    this.GetHighScoreFormatString.bind(this),
                    this.GetHighestBoardsFormatString.bind(this),
                    this.GetBoardsFormatString.bind(this),
                    this.GetAverageBoardsFormatString.bind(this),
                    this.GetHighestPeaksClearedFormatString.bind(this),
                    this.GetPeaksClearedFormatString.bind(this),
                    this.GetAveragePeaksClearedFormatString.bind(this),
                    this.GetLongestCardsChainedFormatString.bind(this)
                ];

            this._gameStats = {};
            _.forEach(this.GetKeys(SolitaireGameMode.Klondike), function (k) {
                this._gameStats[k.Key] = klondike;
            }, this);

            _.forEach(this.GetKeys(SolitaireGameMode.Spider), function (k) {
                this._gameStats[k.Key] = spider;
            }, this);

            _.forEach(this.GetKeys(SolitaireGameMode.FreeCell), function (k) {
                this._gameStats[k.Key] = freecell;
            }, this);

            _.forEach(this.GetKeys(SolitaireGameMode.Pyramid), function (k) {
                this._gameStats[k.Key] = pyramid;
            }, this);

            _.forEach(this.GetKeys(SolitaireGameMode.TriPeaks), function (k) {
                this._gameStats[k.Key] = tripeaks;
            }, this);

        };


        SolitaireStatistics.prototype.GetKeys = function (gameMode) {
            return this._statKeys[SolitaireGameMode.getModeById(gameMode)];
        };

        SolitaireStatistics.prototype.GetAllStats = function (/* StatKey */ game) {
            var ret = [];
            try {
                var stats = this._gameStats[game.Key];

                _.forEach(stats, function (s) {
                    ret.push(s(game));
                }, this);
            }
            catch (e) {
            }

            return ret;
        };
        /*
         SolitaireStatistics.prototype.GetStatisticToChooseDialog(Dictionary<string, SyncedData> data,
         out string titles, out string statVals)
         {
         Func<SolitaireGameMode, string, int> getGamsPayed = (mode, key) =>
         {
         int total = 0;
         foreach (var itemKey in _statKeys[mode])
         {
         var statKey = (itemKey.Key + key).ToLower();
         total += int.Parse((data.ContainsKey(statKey)) ? data[statKey].Value : "0");
         }
         return total;
         };

         Func<string, string> statValue = key =>
         {
         var lowKey = key.ToLower();
         return (data.ContainsKey(lowKey)) ? data[lowKey].Value : "0";
         };

         titles = "";
         statVals = "";

         int totalGamePayed = getGamsPayed(SolitaireGameMode.Klondike, "GamesPlayed") +
         getGamsPayed(SolitaireGameMode.Spider, "GamesPlayed") +
         getGamsPayed(SolitaireGameMode.FreeCell, "GamesPlayed") +
         getGamsPayed(SolitaireGameMode.Pyramid, "GamesPlayed") +
         getGamsPayed(SolitaireGameMode.TriPeaks, "GamesPlayed");

         int totalGameWon = getGamsPayed(SolitaireGameMode.Klondike, "TotalGamesWon") +
         getGamsPayed(SolitaireGameMode.Spider, "TotalGamesWon") +
         getGamsPayed(SolitaireGameMode.FreeCell, "TotalGamesWon") +
         getGamsPayed(SolitaireGameMode.Pyramid, "TotalGamesWon") +
         getGamsPayed(SolitaireGameMode.TriPeaks, "TotalGamesWon");

         titles += LocalizationManager.GetLocalizedString("GamesPlayed_Title/Text");
         statVals += totalGamePayed;

         titles += "\n";
         statVals += "\n";

         titles += LocalizationManager.GetLocalizedString("GamesWon_Title/Text");
         statVals += totalGameWon;


         var lastSave = statValue(LASTSAVEDATE);
         try
         {
         titles += "\n";
         statVals += "\n";

         DateTime date = DateTime.Parse(lastSave, CultureInfo.InvariantCulture);
         titles += LocalizationManager.GetCommonString("LastSaveLabelText");
         statVals += date.ToString("", LocalizationManager.CurrentCulture);
         }
         catch
         {

         }
         }
         */
//#region Streak

        SolitaireStatistics.prototype.GetLongestWinningStreakFormatString = function (game) {
            var val = this.GetLongestWinningStreak(game);
            return this.GetStringFormat(val);
        };

        SolitaireStatistics.prototype.GetLongestWinningStreak = function (game) {
            var key = game.Key + SolitaireStatistics.LONGESTWINNINGSTREAK;
            var value = 0;
            if (StringComparison.StartsWith(key, "+TOTAL", StringComparison.OrdinalIgnoreCase)) {
                key = key.substring(6);
                value = this.BestStat(key, game.GameMode);
            }
            else {
                value = StatManager.GetValue(key);
            }
            return value;
        };

        SolitaireStatistics.prototype.GetLongestLosingStreakFormatString = function (game) {
            var val = this.GetLongestLosingStreak(game);
            return this.GetStringFormat(val);
        };

        SolitaireStatistics.prototype.GetLongestLosingStreak = function (game) {
            var key = game.Key + SolitaireStatistics.LONGESTLOSINGSTREAK;
            var value = 0;
            if (StringComparison.StartsWith(key, "+TOTAL", StringComparison.OrdinalIgnoreCase)) {
                key = key.substring(6);
                value = this.BestStat(key, game.GameMode);
            }
            else {
                value = StatManager.GetValue(key);
            }
            return value;
        };

        SolitaireStatistics.prototype.GetLosingStreak = function (game) {
            var key = game.Key + SolitaireStatistics.LOSINGSTREAK;
            var value = 0;
            if (StringComparison.StartsWith(key, "+TOTAL", StringComparison.OrdinalIgnoreCase)) {
                key = key.substring(6);
                value = this.BestStat(key, game.GameMode);
            }
            else {
                value = StatManager.GetValue(key);
            }
            return value;
        };

        SolitaireStatistics.prototype.GetWinningStreakFormatString = function (game) {
            var val = this.GetWinningStreak(game);
            return this.GetStringFormat(val);
        };

        SolitaireStatistics.prototype.GetWinningStreak = function (game) {
            var key = game.Key + SolitaireStatistics.WINNINGSTREAK;
            var value = 0;
            if (StringComparison.StartsWith(key, "+TOTAL", StringComparison.OrdinalIgnoreCase)) {
                key = key.substring(6);
                value = this.BestStat(key, game.GameMode);
            }
            else {
                value = StatManager.GetValue(key);
            }
            return value;
        };

        SolitaireStatistics.prototype.GetStringFormat = function (val) {
            val = Math.round(val);
            var t = val * 1000,
                i = Math.floor(Math.round(t) / 1000),
                r = t % 1000;
            var str = TextUtils.formatInt(i) + (r ? "." + Math.abs(Math.round(r)) : "");
            return str == "" ? "0" : str;
        };

        SolitaireStatistics.prototype.UpdateLongestWinningStreak = function (game, value) {
            var key = game.Key + SolitaireStatistics.LONGESTWINNINGSTREAK;
            SolitaireStatistics.SetStatistic(key, value, true);
        };

        SolitaireStatistics.prototype.UpdateLongestLosingStreak = function (game, value) {
            var key = game.Key + SolitaireStatistics.LONGESTLOSINGSTREAK;
            SolitaireStatistics.SetStatistic(key, value, true);
        };

        SolitaireStatistics.prototype.IncrementWinningStreak = function (game) {
            var key = game.Key + SolitaireStatistics.WINNINGSTREAK;
            SolitaireStatistics.IncrementStatistic(key, 1, true);

            if (StatManager.GetValue(key) > StatManager.GetValue(game.Key + SolitaireStatistics.LONGESTWINNINGSTREAK)) {
                this.UpdateLongestWinningStreak(game, StatManager.GetValue(key));
            }
            return StatManager.GetValue(key);
        };

        SolitaireStatistics.prototype.IncrementLosingStreak = function (game) {
            var key = game.Key + SolitaireStatistics.LOSINGSTREAK;
            SolitaireStatistics.IncrementStatistic(key, 1, true);

            if (StatManager.GetValue(key) > StatManager.GetValue(game.Key + SolitaireStatistics.LONGESTLOSINGSTREAK)) {
                this.UpdateLongestLosingStreak(game, StatManager.GetValue(key));
            }
            return StatManager.GetValue(key);
        };

        SolitaireStatistics.prototype.ResetWinningStreak = function (game) {
            var key = game.Key + SolitaireStatistics.WINNINGSTREAK;
            SolitaireStatistics.SetStatistic(key, 0, true);
        };

        SolitaireStatistics.prototype.ResetLosingStreak = function (game) {
            var key = game.Key + SolitaireStatistics.LOSINGSTREAK;
            SolitaireStatistics.SetStatistic(key, 0, true);
        };

        SolitaireStatistics.prototype.GetGlobalWinningStreak = function () {
            return StatManager.GetValue(SolitaireStatistics.GlobalStreak);
        };

        SolitaireStatistics.prototype.IncrementGlobalWinningStreak = function () {
            SolitaireStatistics.IncrementStatistic(SolitaireStatistics.GlobalStreak, 1, true);
        };

        SolitaireStatistics.prototype.ResetGlobalWinningStreak = function () {
            SolitaireStatistics.SetStatistic(SolitaireStatistics.GlobalStreak, 0, true);
        };

//#endregion

//#region GamesPlayed

        SolitaireStatistics.prototype.GetTotalGamesPlayed = function () {
            return StatManager.GetValue(SolitaireStatistics.GAMESPLAYEDTOTAL);
        };

        SolitaireStatistics.prototype.GetGamesPlayedFormatString = function (game) {
            var val = this.GetGamesPlayed(game);
            return this.GetStringFormat(val);
        };

        SolitaireStatistics.prototype.GetGamesPlayed = function (game) {
            var key = game.Key + SolitaireStatistics.GAMESPLAYEDSUFFIX;
            var value = 0;
            if (StringComparison.StartsWith(key, "+TOTAL", StringComparison.OrdinalIgnoreCase)) {
                key = key.substring(6);
                value = this.TotalStat(key, game.GameMode);
            }
            else {
                value = StatManager.GetValue(key);
            }
            return value;
        };

        SolitaireStatistics.prototype.SetGamesPlayed = function (game, value) {
            var key = game.Key + SolitaireStatistics.GAMESPLAYEDSUFFIX;
            SolitaireStatistics.SetStatistic(key, value, true);
        };

        SolitaireStatistics.prototype.UpdateGamesPlayed = function (game) {
            SolitaireStatistics.IncrementStatistic(SolitaireStatistics.GAMESPLAYEDTOTAL, 1);
            SolitaireStatistics.IncrementStatistic(game.Key + SolitaireStatistics.GAMESPLAYEDSUFFIX, 1);
            //SimpleIoc.Default.GetInstance<StatisticsMenuDataSource>().Update();
        };

//#endregion

//#region OptInAds

        SolitaireStatistics.prototype.GetNextAdShowPeriod = function (game) {
            var key = game.Key + SolitaireStatistics.NEXTADSHOWINGPERIOD;
            var value = StatManager.GetValue(key);
            return value;
        };

        SolitaireStatistics.prototype.SetNextAdShowPeriod = function (game, value) {
            if (game.GameMode != SolitaireGameMode.TriPeaks && game.GameMode != SolitaireGameMode.Pyramid) return;
            SolitaireStatistics.SetStatistic(game.GameMode.ToString() + SolitaireStatistics.NEXTADSHOWINGPERIOD, value, true);
        };

        SolitaireStatistics.prototype.GetGamesPlayedSinceLastAdShowing = function (game) {
            var key = game.Key + SolitaireStatistics.GAMESPLAYEDSINCELASTADSHOWING;
            var value = StatManager.GetValue(key);
            return value;
        };

        SolitaireStatistics.prototype.SetGamesPlayedSinceLastAdShowing = function (game, value) {
            if (game.GameMode != SolitaireGameMode.TriPeaks && game.GameMode != SolitaireGameMode.Pyramid) return;
            SolitaireStatistics.SetStatistic(game.GameMode.ToString() + SolitaireStatistics.GAMESPLAYEDSINCELASTADSHOWING, value, true);
        };

//#endregion

//#region GamesWon
        SolitaireStatistics.prototype.AddGamesWon = function (game, value) {
            SolitaireStatistics.IncrementStatistic(SolitaireStatistics.GAMESWONTOTAL, 1);
            SolitaireStatistics.IncrementStatistic(game.Key + SolitaireStatistics.GAMESWONTOTAL, 1);

            return StatManager.GetValue(game.Key + SolitaireStatistics.GAMESWONTOTAL);
        };

        SolitaireStatistics.prototype.GetGamesWonFormatString = function (game) {
            var val = this.GetGamesWonTotal(game);
            return this.GetStringFormat(val);
        };

        SolitaireStatistics.prototype.GetGamesWonTotal = function (games) {
            if (!games) {
                return StatManager.GetValue(SolitaireStatistics.GAMESWONTOTAL);
            }
            else if (typeof games == "array") {
                var sum = 0;
                _.forEach(games, function (game) {
                    sum += this.GetGamesWonTotal(game);
                }, this);
                return sum;
            }
            else if (games instanceof SolitaireStatistics.StatKey) {
                var key = games.Key + SolitaireStatistics.GAMESWONTOTAL;
                var value = 0;
                if (StringComparison.StartsWith(key, "+TOTAL", StringComparison.OrdinalIgnoreCase)) {
                    key = key.substring(6);
                    value = this.TotalStat(key, games.GameMode);
                }
                else {
                    value = StatManager.GetValue(key);
                }
                return value;
            }
            else {
                return 0;
            }
        };
//#endregion

//#region GamesLost
        SolitaireStatistics.prototype.GetGamesLostTotal = function (game) {
            var won = this.GetGamesWonTotal(game);
            var total = this.GetGamesPlayed(game);
            return total - won;
        };

        SolitaireStatistics.prototype.GetGamesLostFormatString = function (game) {
            var val = this.GetGamesLostTotal(game);
            return this.GetStringFormat(val);
        };

//#endregion

//#region Percentages
        SolitaireStatistics.prototype.GetPercentWon = function (game) {
            var percentage = 0;
            if (game) {
                percentage = this.GetWinPercentage(game);
            }
            else {
                var total = this.GetTotalGamesPlayed();
                var won = this.GetGamesWonTotal();
                percentage = this.GetPercentage(won, total);
            }

            //return percentage.ToString("0%", CultureInfo.CurrentCulture);
            return Math.round(100 * percentage) + "%";
        };


        SolitaireStatistics.prototype.GetWinPercentage = function (game) {
            var total = this.GetGamesPlayed(game);
            var won = this.GetGamesWonTotal(game);

            return this.GetPercentage(won, total);
        };

        SolitaireStatistics.prototype.GetPercentage = function (top, bottom) {
            return bottom > 0 ? (top / bottom) : 0;
        };
//#endregion

//#region GameAction Update
        SolitaireStatistics.prototype.UpdateGameAction = function (gameMode) {
            return;
            /*
             UpdateBoards(gameMode);
             UpdateHighestBoards(gameMode);
             UpdateStacks(gameMode);
             UpdateRowsCleared(gameMode);
             UpdateHighestRowsCleared(gameMode);
             UpdateMatches(gameMode);
             UpdateHighestMatches(gameMode);
             UpdatePeaksCleared(gameMode);
             UpdateHighestPeaksCleared(gameMode);
             UpdateLongestCardsChained(gameMode);

             //Check for stats based acheivements
             foreach (var a in Enum.GetValues(typeof(SolitaireAchievements.SolitaireAchievement)))
             {
             SolitaireAchievements.Instance.CheckForAchievement((SolitaireAchievements.SolitaireAchievement)a);
             }
             */
        };
//#endregion

//#region GameReDeal Update

        SolitaireStatistics.prototype.UpdateGameRedeal = function (gameMode) {
            this.UpdateGamesPlayed(gameMode);
            this.ResetWinningStreak(gameMode);
            this.IncrementLosingStreak(gameMode);
            this.UpdateBoards(gameMode);
            this.UpdateHighestBoards(gameMode);
            this.UpdateStacks(gameMode);
            this.UpdateRowsCleared(gameMode);
            this.UpdateHighestRowsCleared(gameMode);
            this.UpdateMatches(gameMode);
            this.UpdateHighestMatches(gameMode);
            this.UpdatePeaksCleared(gameMode);
            this.UpdateHighestPeaksCleared(gameMode);
            this.UpdateLongestCardsChained(gameMode);
            this.UpdateTotalTime(gameMode);
            this.UpdateBoardWonWithKing(gameMode);
            SolitaireStatistics.UpdateWriteCurDate();
            this.ResetGlobalWinningStreak();
            this.UpdateCumulativeKlondikeScore(gameMode);
            StatManager.Save();
            //SolitaireAwardsService.RefreshProgress();

            // TODO ?SolitaireAchievements.Instance.CheckForAchievement(SolitaireAchievements.SolitaireAchievement.BoardYet);
        };

//#endregion

//#region GameWonLost Update
        SolitaireStatistics.prototype.UpdateGameWon = function (gameMode) {
            this.UpdateGamesPlayed(gameMode);
            this.AddGamesWon(gameMode, 1);
            this.ResetLosingStreak(gameMode);
            this.IncrementWinningStreak(gameMode);
            this.UpdateBoards(gameMode);
            this.UpdateHighestBoards(gameMode);
            this.UpdateStacks(gameMode);
            this.UpdateRowsCleared(gameMode);
            this.UpdateHighestRowsCleared(gameMode);
            this.UpdateMatches(gameMode);
            this.UpdateHighestMatches(gameMode);
            this.UpdatePeaksCleared(gameMode);
            this.UpdateHighestPeaksCleared(gameMode);
            this.SaveHighScore(gameMode);
            this.UpdateLongestCardsChained(gameMode);
            this.UpdateBestTime(gameMode);
            this.UpdateTotalTime(gameMode);
            this.UpdateBoardWonWithKing(gameMode);
            this.UpdateGamesWonInARowWin(gameMode);
            SolitaireStatistics.UpdateWriteCurDate();
            this.IncrementGlobalWinningStreak();
            StatManager.Save();

            //User has won a game so award achievement Well Played
            // TODO ? SolitaireAchievements.Instance.AwardAchievement(SolitaireAchievements.SolitaireAchievement.WellPlayed);

            /*
             TODO ?

             //Check for stats based acheivements
             foreach (var a in Enum.GetValues(typeof(SolitaireAchievements.SolitaireAchievement)))
             {
             SolitaireAchievements.Instance.CheckForAchievement((SolitaireAchievements.SolitaireAchievement)a);
             }

             SolitaireAwardsHelper.UpdateAwardsAsync(SolitaireAwardsUpdateContextFlags.OnGameWin);
             SolitaireAwardsService.RefreshProgress();
             */
        };

        SolitaireStatistics.prototype.UpdateGameLost = function (gameMode) {
            this.UpdateGamesPlayed(gameMode);
            this.ResetWinningStreak(gameMode);
            this.IncrementLosingStreak(gameMode);
            this.UpdateBoards(gameMode);
            this.UpdateHighestBoards(gameMode);
            this.UpdateStacks(gameMode);
            this.UpdateRowsCleared(gameMode);
            this.UpdateHighestRowsCleared(gameMode);
            this.UpdatePeaksCleared(gameMode);
            this.UpdateHighestPeaksCleared(gameMode);
            this.UpdateMatches(gameMode);
            this.UpdateHighestMatches(gameMode);
            this.SaveHighScore(gameMode);
            this.UpdateLongestCardsChained(gameMode);
            this.UpdateTotalTime(gameMode);
            //  UpdateBoardWonWithKing(gameMode);
            this.UpdateGamesWonInARowLose(gameMode);
            SolitaireStatistics.UpdateWriteCurDate();
            this.ResetGlobalWinningStreak();
            StatManager.Save();

            /*
             TODO ?

             //Check for stats based acheivements
             foreach (var a in Enum.GetValues(typeof(SolitaireAchievements.SolitaireAchievement)))
             {
             SolitaireAchievements.Instance.CheckForAchievement((SolitaireAchievements.SolitaireAchievement)a);
             }
             SolitaireAwardsService.RefreshProgress();
             */
        };
//#endregion

//#region Score


        SolitaireStatistics.prototype.GetScoreFormatString = function (game) {
            var score = this.GetScore(game);
            return this.GetStringFormat(score);
        };

        SolitaireStatistics.prototype.GetScore = function (game) {
            if (game.GameMode == SolitaireGameMode.FreeCell) {
                return 0;
            }

            if (GameState.CurrentGame.Authority != null && GameState.CurrentGame.Authority.CardSupply != null)
                return GameState.CurrentGame.Authority.CardSupply.Score;
            else
                return 0;
        };

        SolitaireStatistics.prototype.GetHighScoreFormatString = function (game) {
            var score = this.GetHighScore(game);
            return this.GetStringFormat(score);
        };

        SolitaireStatistics.prototype.UpdateCumulativeKlondikeScore = function (game) {
            if (game.GameMode != SolitaireGameMode.Klondike || (game.Key.toLowerCase().indexOf("cumulative") == -1))
                return;
            var score = this.GetScore(game);
            var totalkey = game.Key + SolitaireStatistics.TOTALSCORE;
            SolitaireStatistics.SetStatistic(totalkey, score);
        };

        SolitaireStatistics.prototype.GetHighScore = function (game) {
            var key = game.Key + SolitaireStatistics.HIGHSCORE;
            var value = 0;
            if (StringComparison.StartsWith(key, "+TOTAL", StringComparison.OrdinalIgnoreCase)) {
                key = key.substring(6);
                value = this.BestStat(key, game.GameMode);
            }
            else {
                value = StatManager.GetValue(key);
            }
            return value;
        };

        SolitaireStatistics.prototype.TotalStat = function (key, mode) {
            key = key.substring(SolitaireGameMode.getModeById(mode).length);
            var total = 0;
            _.forEach(this._statKeys[SolitaireGameMode.getModeById(mode)], function (itemKey) {
                var statKey = itemKey.Key + key;
                total += StatManager.GetValue(statKey);
            }, this);
            return total;
        };

        SolitaireStatistics.prototype.BestStat = function (key, mode) {
            key = key.substring(SolitaireGameMode.getModeById(mode).length);
            var total = 0;
            _.forEach(this._statKeys[SolitaireGameMode.getModeById(mode)], function (itemKey) {
                var statKey = itemKey.Key + key;
                var newVal = StatManager.GetValue(statKey);
                if (newVal > total)
                    total = newVal;
            }, this);
            return total;
        };

        SolitaireStatistics.prototype.SaveHighScore = function (game) {
            if (game.GameMode == SolitaireGameMode.FreeCell) {
                return;
            }
            var key = game.Key + SolitaireStatistics.HIGHSCORE;
            var score = this.GetScore(game);
            if (!StatManager.ValueExists(key) || score > this.GetHighScore(game)) {
                SolitaireStatistics.SetStatistic(key, score);
            }
            var total = 0;
            if (game.Key.toLowerCase().indexOf("cumulative") == -1)
                total = this.GetTotalScore(game);
            var totalkey = game.Key + SolitaireStatistics.TOTALSCORE;
            SolitaireStatistics.SetStatistic(totalkey, score + total);
        };

        SolitaireStatistics.prototype.GetTotalScore = function (game) {
            var key = game.Key + SolitaireStatistics.TOTALSCORE;
            var value;
            if (StringComparison.StartsWith(key, "+TOTAL", StringComparison.OrdinalIgnoreCase)) {
                key = key.substring(6);
                value = this.BestStat(key, game.GameMode);
            }
            else {
                value = StatManager.GetValue(key);
            }
            return value;
        };

        SolitaireStatistics.prototype.GetAverageScore = function (game) {
            var score = this.GetTotalScore(game);
            var games = this.GetGamesPlayed(game);
            if (games <= 0) return 0;
            return score / games;
        };

        SolitaireStatistics.prototype.GetAverageScoreFormatString = function (game) {
            var score = this.GetAverageScore(game);
            return this.GetStringFormat(score);
        };

//#endregion

//#region Matches

        SolitaireStatistics.prototype.GetMatchesFormatString = function (game) {
            var score = this.GetMatches(game);
            return this.GetStringFormat(score);
        };

        SolitaireStatistics.prototype.GetMatches = function (game) {
            var key = game.Key + SolitaireStatistics.MATCHES;
            var value = 0;
            if (StringComparison.StartsWith(key, "+TOTAL", StringComparison.OrdinalIgnoreCase)) {
                key = key.substring(6);
                value = this.TotalStat(key, game.GameMode);
            }
            else {
                value = StatManager.GetValue(key);
            }
            return value;
        };

        SolitaireStatistics.prototype.UpdateMatches = function (game) {
            if (game.GameMode != SolitaireGameMode.Pyramid) {
                return;
            }
            var currentAuthority = GameState.CurrentGame.Authority != null ? GameState.CurrentGame.Authority : null;
            var newMatches = 0;
            var key = game.Key + SolitaireStatistics.MATCHES;
            var currentMatches = this.GetMatches(game);

            if (GameState.CurrentGame.Authority != null) {
                newMatches = currentAuthority.Matches;
            }
            SolitaireStatistics.SetStatistic(key, (currentMatches + newMatches));
        };

        SolitaireStatistics.prototype.GetHighestMatchesFormatString = function (game) {
            var val = this.GetHighestMatches(game);
            return this.GetStringFormat(val);
        };

        SolitaireStatistics.prototype.GetHighestMatches = function (game) {
            var key = game.Key + SolitaireStatistics.HIGHESTMATCHES;
            return StatManager.GetValue(key);
        };

        SolitaireStatistics.prototype.UpdateHighestMatches = function (game) {
            if (game.GameMode != SolitaireGameMode.Pyramid) {
                return;
            }
            var currentAuthority = GameState.CurrentGame.Authority != null ? GameState.CurrentGame.Authority : null;
            var matches = 0;
            var key = game.Key + SolitaireStatistics.HIGHESTMATCHES;
            var currentMatches = this.GetHighestMatches(game);

            if (GameState.CurrentGame.Authority != null) {
                matches = currentAuthority.Matches;
            }

            if (matches > currentMatches)
                SolitaireStatistics.SetStatistic(key, matches);
        };

        SolitaireStatistics.prototype.GetAverageMatchesFormatString = function (game) {
            var val = this.GetAverageMatches(game);
            return this.GetStringFormat(val);
        };

        SolitaireStatistics.prototype.GetAverageMatches = function (game) {
            var matches = this.GetMatches(game);
            var games = this.GetGamesPlayed(game);
            return games > 0 ? matches / games : 0;
        };


//#endregion

//#region Stacks

        SolitaireStatistics.prototype.GetStacksFormatString = function (game) {
            var val = this.GetStacks(game);
            return this.GetStringFormat(val);
        };

        SolitaireStatistics.prototype.GetAverageStacksFormatString = function (game) {
            var val = this.GetAverageStacks(game);
            return this.GetStringFormat(val);
        };

        SolitaireStatistics.prototype.GetStacks = function (game) {
            if (game.GameMode != SolitaireGameMode.Spider) {
                return 0;
            }
            var key = game.Key + SolitaireStatistics.STACKSMADE;
            var value = 0;
            if (StringComparison.StartsWith(key, "+TOTAL", StringComparison.OrdinalIgnoreCase)) {
                key = key.substring(6);
                value = this.TotalStat(key, game.GameMode);
            }
            else {
                value = StatManager.GetValue(key);
            }
            return value;
        };

        SolitaireStatistics.prototype.GetAverageStacks = function (game) {
            var stacks = this.GetStacks(game);
            var games = this.GetGamesPlayed(game);
            return games > 0 ? stacks / games : 0;
        };

        SolitaireStatistics.prototype.UpdateStacks = function (game) {
            if (game.GameMode != SolitaireGameMode.Spider) {
                return;
            }

            var stacks = 0;
            var key = game.Key + SolitaireStatistics.STACKSMADE;
            var currentStacks = this.GetStacks(game);

            if (GameState.CurrentGame.Authority != null && GameState.CurrentGame.Authority.CardSupply != null) {
                stacks = GameState.CurrentGame.Authority.GetCompletedStacks();
            }
            SolitaireStatistics.SetStatistic(key, (currentStacks + stacks));
        };

//#endregion

//#region Boards

        SolitaireStatistics.prototype.GetBoardsFormatString = function (game) {
            var val = this.GetBoards(game);
            return this.GetStringFormat(val);
        };

        SolitaireStatistics.prototype.GetBoards = function (games) {
            
            if (!games) {
                return StatManager.GetValue(SolitaireStatistics.BOARDSCLEARED);
            }
            else if (typeof games == "array") {
                var sum = 0;
                _.forEach(games, function (game) {
                    sum += this.GetBoards(game);
                }, this);
                return sum;
            }
            else if (games instanceof SolitaireStatistics.StatKey) {
                var value = 0;
                var key = games.Key + SolitaireStatistics.BOARDSCLEARED;
                if (StringComparison.StartsWith(key, "+TOTAL", StringComparison.OrdinalIgnoreCase)) {
                    key = key.substring(6);
                    value = this.TotalStat(key, games.GameMode);
                }
                else {
                    value = StatManager.GetValue(key);
                }
                return value;
            }
            else {
                return 0;
            }

        };

        SolitaireStatistics.prototype.UpdateBoards = function (game) {
            if (game.GameMode != SolitaireGameMode.TriPeaks && game.GameMode != SolitaireGameMode.Pyramid) {
                return;
            }

            var boards = 0;
            var key = game.Key + SolitaireStatistics.BOARDSCLEARED;
            var currentBoards = this.GetBoards(game);

            if (GameState.CurrentGame.Authority != null && GameState.CurrentGame.Authority.CardSupply != null) {
                boards = GameState.CurrentGame.Authority.BoardsCompleted();
            }
            SolitaireStatistics.SetStatistic(key, (currentBoards + boards));
        };

        SolitaireStatistics.prototype.GetHighestBoardsFormatString = function (game) {
            var val = this.GetHighestBoards(game);
            return this.GetStringFormat(val);
        };

        SolitaireStatistics.prototype.GetHighestBoards = function (game) {
            var key = game.Key + SolitaireStatistics.HIGHESTBOARDSCLEARED;
            return StatManager.GetValue(key);
        };

        SolitaireStatistics.prototype.UpdateHighestBoards = function (game) {
            if (game.GameMode != SolitaireGameMode.TriPeaks && game.GameMode != SolitaireGameMode.Pyramid) {
                return;
            }

            var boards = 0;
            var key = game.Key + SolitaireStatistics.HIGHESTBOARDSCLEARED;
            var currentBoards = this.GetHighestBoards(game);

            if (GameState.CurrentGame.Authority != null && GameState.CurrentGame.Authority.CardSupply != null) {
                boards = GameState.CurrentGame.Authority.BoardsCompleted();
            }

            if (boards > currentBoards)
                SolitaireStatistics.SetStatistic(key, boards);
        };

        SolitaireStatistics.prototype.GetAverageBoardsFormatString = function (game) {
            var val = this.GetAverageBoards(game);
            return this.GetStringFormat(val);
        };

        SolitaireStatistics.prototype.GetAverageBoards = function (game) {
            var boards = this.GetBoards(game);
            var games = this.GetGamesPlayed(game);
            return games > 0 ? boards / games : 0;
        };

//#endregion

//#region RowsCleared

        SolitaireStatistics.prototype.GetRowsClearedFormatString = function (game) {
            var score = this.GetRowsCleared(game);
            return this.GetStringFormat(score);
        };

        SolitaireStatistics.prototype.GetRowsCleared = function (game) {
            var key = game.Key + SolitaireStatistics.ROWSCLEARED;
            var value = 0;
            if (StringComparison.StartsWith(key, "+TOTAL", StringComparison.OrdinalIgnoreCase)) {
                key = key.substring(6);
                value = this.TotalStat(key, game.GameMode);
            }
            else {
                value = StatManager.GetValue(key);
            }
            return value;
        };

        SolitaireStatistics.prototype.UpdateRowsCleared = function (game) {
            if (game.GameMode != SolitaireGameMode.Pyramid) {
                return;
            }
            var currentAuthority = GameState.CurrentGame.Authority != null ? GameState.CurrentGame.Authority : null;
            var rows = 0;
            var key = game.Key + SolitaireStatistics.ROWSCLEARED;
            var currentRows = this.GetRowsCleared(game);

            if (GameState.CurrentGame.Authority != null) {
                if (currentAuthority != null) {
                    rows = currentAuthority.RowsCleared;
                }
            }
            SolitaireStatistics.SetStatistic(key, (currentRows + rows));
        };

        SolitaireStatistics.prototype.GetHighestRowsClearedFormatString = function (game) {
            var val = this.GetHighestRowsCleared(game);
            return this.GetStringFormat(val);
        };

        SolitaireStatistics.prototype.GetHighestRowsCleared = function (game) {
            var key = game.Key + SolitaireStatistics.HIGHESTROWSCLEARED;
            return StatManager.GetValue(key);
        };

        SolitaireStatistics.prototype.UpdateHighestRowsCleared = function (game) {
            if (game.GameMode != SolitaireGameMode.Pyramid) {
                return;
            }
            var currentAuthority = GameState.CurrentGame.Authority != null ? GameState.CurrentGame.Authority : null;
            var rows = 0;
            var key = game.Key + SolitaireStatistics.HIGHESTROWSCLEARED;
            var currentRows = this.GetHighestRowsCleared(game);

            if (GameState.CurrentGame.Authority != null) {
                if (currentAuthority != null) {
                    rows = currentAuthority.RowsCleared;
                }
            }

            if (rows > currentRows) {
                SolitaireStatistics.SetStatistic(key, rows);
            }
        };


        SolitaireStatistics.prototype.GetAverageRowsClearedFormatString = function (game) {
            var val = this.GetAverageRowsCleared(game);
            return this.GetStringFormat(val);
        };

        SolitaireStatistics.prototype.GetAverageRowsCleared = function (game) {
            var rows = this.GetRowsCleared(game);
            var games = this.GetGamesPlayed(game);
            return games > 0 ? rows / games : 0;
        };

//#endregion

//#region CardsChained

        SolitaireStatistics.prototype.GetCardsChainedFormatString = function (game) {
            var chain = this.GetCardsChained(game);
            return this.GetStringFormat(chain);
        };

        SolitaireStatistics.prototype.GetCardsChained = function (game) {
            if (game.GameMode != SolitaireGameMode.TriPeaks) {
                return 0;
            }

            var currentAuthority;
            try {
                currentAuthority = GameState.CurrentGame.Authority != null ? GameState.CurrentGame.Authority : null;
            }
            catch (InvalidCastException) {
                currentAuthority = null;
            }
            var chains = 0;
            if (currentAuthority != null) {
                chains = currentAuthority.CardsChained;
            }

            return chains;
        };

        SolitaireStatistics.prototype.GetLongestCardsChainedFormatString = function (game) {
            var chain = this.GetLongestCardsChained(game);
            return this.GetStringFormat(chain);
        };

        SolitaireStatistics.prototype.GetLongestCardsChained = function (game) {
            var key = game.Key + SolitaireStatistics.CARDSCHAINED;
            return StatManager.GetValue(key);
        };

        SolitaireStatistics.prototype.UpdateLongestCardsChained = function (game) {
            if (game.GameMode != SolitaireGameMode.TriPeaks) {
                return;
            }
            var key = game.Key + SolitaireStatistics.CARDSCHAINED;
            var currentChain = this.GetLongestCardsChained(game);
            var chains = this.GetCardsChained(game);

            if (chains > currentChain) {
                SolitaireStatistics.SetStatistic(key, chains);
            }
        };

//#endregion

//#region Time

        SolitaireStatistics.prototype.GetTimeFormat = function (seconds) {
            var td = new Date(1000 * seconds);

            var hours = td.getUTCHours(),
                mins = td.getUTCMinutes(),
                secs = td.getUTCSeconds();

            return (hours > 0 ? hours + ":" : "") + (mins + ":") + (secs < 10 ? "0" + secs : secs);
            /*
             var currentTime = TimeSpan.FromSeconds(seconds);

             currentTime = new TimeSpan(
             currentTime.Hours >= 0 ? currentTime.Hours + (currentTime.Days * 24) : 0,
             currentTime.Minutes >= 0 ? currentTime.Minutes : 0,
             currentTime.Seconds >= 0 ? currentTime.Seconds : 0);

             string retTime;
             if (currentTime.Hours > 0)
             {
             try
             {
             retTime = currentTime.ToString(LocalizationManager.GetLocalizedString("Time_Format_HoursMinutesSeconds"));
             }
             catch (FormatException)
             {
             retTime = currentTime.ToString("h':'mm':'ss");
             }
             }
             else
             {
             try
             {
             retTime = currentTime.ToString(LocalizationManager.GetLocalizedString("Time_Format_MinutesSeconds"));
             }
             catch (FormatException)
             {
             retTime = currentTime.ToString("m':'ss");
             }
             }

             return retTime;
             */
        };

        SolitaireStatistics.prototype.GetTimeFormatString = function (game) {
            var time = this.GetTime();
            return this.GetTimeFormat(time);
        };

        SolitaireStatistics.prototype.GetBestTimeFormatString = function (game) {
            var time = this.GetBestTime(game);
            return this.GetTimeFormat(time);
        };

        SolitaireStatistics.prototype.GetAverageTimeFormatString = function (game) {
            var time = this.GetAverageTime(game);
            return this.GetTimeFormat(time);
        };

        SolitaireStatistics.prototype.GetTime = function () {
            var time = 0;
            if (GameState.CurrentGame.Authority != null) {
                time = GameState.CurrentGame.Authority.CardSupply.CurrentTime;
            }

            return time;
        };

        SolitaireStatistics.prototype.GetBestTime = function (game) {
            var key = game.Key + SolitaireStatistics.GAMEBESTTIME;
            var value = 0;
            if (StringComparison.StartsWith(key, "+TOTAL", StringComparison.OrdinalIgnoreCase)) {
                key = key.substring(6);
                value = this.TotalStat(key, game.GameMode);
            }
            else {
                value = StatManager.GetValue(key);
            }
            return value;
        };

        SolitaireStatistics.prototype.GetTotalTime = function (game) {
            var key = game.Key + SolitaireStatistics.GAMETIME;
            var value = 0;
            if (StringComparison.StartsWith(key, "+TOTAL", StringComparison.OrdinalIgnoreCase)) {
                key = key.substring(6);
                value = this.TotalStat(key, game.GameMode);
            }
            else {
                value = StatManager.GetValue(key);
            }
            return value;
        };

        SolitaireStatistics.prototype.GetAverageTime = function (game) {
            var time = this.GetTotalTime(game);
            var games = this.GetGamesPlayed(game);

            return games > 0 ? time / games : 0;
        };

        SolitaireStatistics.prototype.UpdateTotalTime = function (game) {
            var key = game.Key + SolitaireStatistics.GAMETIME;
            var currentTime = this.GetTime();
            var currentTotal = this.GetTotalTime(game);

            SolitaireStatistics.SetStatistic(key, (currentTime + currentTotal));
        };

        SolitaireStatistics.prototype.UpdateBestTime = function (game) {
            var key = game.Key + SolitaireStatistics.GAMEBESTTIME;
            var bestTime = this.GetBestTime(game);
            var currentTime = this.GetTime();

            if (currentTime < bestTime || bestTime <= 0) {
                SolitaireStatistics.SetStatistic(key, currentTime);
            }
        };

        SolitaireStatistics.UpdateWriteCurDate = function () {
            var saveDate = new Date().toString();// DateTime.Now.ToString(CultureInfo.InvariantCulture);
            StatManager.SetStatistic(SolitaireStatistics.LASTSAVEDATE, saveDate);
        };

//#endregion

//#region CardsFlipped

        SolitaireStatistics.prototype.GetCardsFlipped = function () {
            var key = SolitaireStatistics.CARDSFLIPPED;
            return StatManager.GetValue(key);
        };

        SolitaireStatistics.prototype.IncrementCardsFlipped = function () {
            var key = SolitaireStatistics.CARDSFLIPPED;
            SolitaireStatistics.SetStatistic(key, this.GetCardsFlipped() + 1);
        };

//#endregion

//#region Kings

        SolitaireStatistics.prototype.GetBoardWonWithKing = function (game) {
            var key = game.Key + SolitaireStatistics.BOARDWONWITHKING;
            return StatManager.GetValue(key);
        };

        SolitaireStatistics.prototype.UpdateBoardWonWithKing = function (game) {
            var key = game.Key + SolitaireStatistics.BOARDWONWITHKING;
            if (game.GameMode == SolitaireGameMode.Pyramid) {
                var currentAuthority = GameState.CurrentGame.Authority != null ? GameState.CurrentGame.Authority : null;
                if (currentAuthority != null && currentAuthority.WonWithKing) {
                    SolitaireStatistics.SetStatistic(key, 1);
                }
            }
            else if (game.GameMode == SolitaireGameMode.TriPeaks) {
                var currentAuthority = GameState.CurrentGame.Authority != null ? GameState.CurrentGame.Authority : null;
                if (currentAuthority != null && currentAuthority.WonWithKing) {
                    SolitaireStatistics.SetStatistic(key, 1);
                }
            }
        };

//#endregion

//#region GamesWonInARow

// this is only for Klondike, Spider and FreeCell.  Used for an acheivement
        SolitaireStatistics.prototype.GetGamesWonInARow = function (game) {
            var key = game.Key + SolitaireStatistics.GAMESWONINAROW;
            return StatManager.GetValue(key);
        };

        SolitaireStatistics.prototype.ClearGamesWonInARow = function (game) {
            var key = game.Key + SolitaireStatistics.GAMESWONINAROW;
            SolitaireStatistics.SetStatistic(key, 0);
        };

        SolitaireStatistics.prototype.IncrementGamesWonInARow = function (game) {
            var key = game.Key + SolitaireStatistics.GAMESWONINAROW;
            SolitaireStatistics.SetStatistic(key, (this.GetGamesWonInARow(game) + 1));
        }

        SolitaireStatistics.prototype.UpdateGamesWonInARowWin = function (game) {
            if (game.GameMode != SolitaireGameMode.Pyramid && game.GameMode != SolitaireGameMode.TriPeaks) {
                this.IncrementGamesWonInARow(game);
            }
        };

        SolitaireStatistics.prototype.UpdateGamesWonInARowLose = function (game) {
            if (game.GameMode != SolitaireGameMode.Pyramid && game.GameMode != SolitaireGameMode.TriPeaks) {
                _.forEach(this.GetKeys(SolitaireGameMode.FreeCell), function (k) {
                    this.ClearGamesWonInARow(k);
                }, this);

                _.forEach(this.GetKeys(SolitaireGameMode.Klondike), function (k) {
                    this.ClearGamesWonInARow(k);
                }, this);

                _.forEach(this.GetKeys(SolitaireGameMode.Spider), function (k) {
                    this.ClearGamesWonInARow(k);
                }, this);

            }
        };
//#endregion

//#region peaks
        SolitaireStatistics.prototype.GetPeaksClearedFormatString = function (game) {
            var score = this.GetPeaksCleared(game);
            return this.GetStringFormat(score);
        };

        SolitaireStatistics.prototype.GetPeaksCleared = function (game) {
            var key = game.Key + SolitaireStatistics.PEAKSCLEARED;
            var value = 0;
            if (StringComparison.StartsWith(key, "+TOTAL", StringComparison.OrdinalIgnoreCase)) {
                key = key.substring(6);
                value = this.TotalStat(key, game.GameMode);
            }
            else {
                value = StatManager.GetValue(key);
            }
            return value;
        };

        SolitaireStatistics.prototype.UpdatePeaksCleared = function (game) {
            if (game.GameMode != SolitaireGameMode.TriPeaks) {
                return;
            }
            var currentAuthority = GameState.CurrentGame.Authority != null ? GameState.CurrentGame.Authority : null;
            var peaks = 0;
            var key = game.Key + SolitaireStatistics.PEAKSCLEARED;
            var currentPeaks = this.GetPeaksCleared(game);

            if (GameState.CurrentGame.Authority != null) {
                if (currentAuthority != null) {
                    peaks = currentAuthority.NumPeaksCleared;
                }
            }
            SolitaireStatistics.SetStatistic(key, (currentPeaks + peaks));
        };

        SolitaireStatistics.prototype.GetHighestPeaksClearedFormatString = function (game) {
            var val = this.GetHighestPeaksCleared(game);
            return this.GetStringFormat(val);
        };

        SolitaireStatistics.prototype.GetHighestPeaksCleared = function (game) {
            var key = game.Key + SolitaireStatistics.HIGHESTPEAKSCLEARED;
            return StatManager.GetValue(key);
        };

        SolitaireStatistics.prototype.UpdateHighestPeaksCleared = function (game) {
            if (game.GameMode != SolitaireGameMode.TriPeaks) {
                return;
            }
            var currentAuthority = GameState.CurrentGame.Authority != null ? GameState.CurrentGame.Authority : null;
            var peaks = 0;
            var key = game.Key + SolitaireStatistics.HIGHESTPEAKSCLEARED;
            var currentPeaks = this.GetHighestPeaksCleared(game);

            if (GameState.CurrentGame.Authority != null) {
                if (currentAuthority != null) {
                    peaks = currentAuthority.NumPeaksCleared;
                }
            }

            if (peaks > currentPeaks) {
                SolitaireStatistics.SetStatistic(key, peaks);
            }
        };

        SolitaireStatistics.SetStatistic = function (key, value, forceLocal) {
            forceLocal = !!forceLocal;

            if (!(GameState.CurrentGame.Authority instanceof IDailyAuthority))
                StatManager.SetStatistic(key, value, forceLocal);
        };

        SolitaireStatistics.IncrementStatistic = function (key, amount, forceLocal) {
            if (!(GameState.CurrentGame.Authority instanceof IDailyAuthority)) {
                forceLocal = !!forceLocal;
                var currval = StatManager.GetValue(key);
                StatManager.SetStatistic(key, currval + amount, forceLocal);
            }
        };

        SolitaireStatistics.prototype.GetAveragePeaksClearedFormatString = function (game) {
            var val = this.GetAveragePeaksCleared(game);
            return this.GetStringFormat(val);
        };

        SolitaireStatistics.prototype.GetAveragePeaksCleared = function (game) {
            var peaks = this.GetPeaksCleared(game);
            var games = this.GetGamesPlayed(game);
            return games > 0 ? peaks / games : 0;
        };


        // DC
        SolitaireStatistics.prototype.GetDCChallengesWonFormatString = function () {
           return this.GetStringFormat(StatManager.GetValue("DCGlobalCompletedChallenges"));
        };

        SolitaireStatistics.prototype.GetDCChallengesPlayedFormatString = function () {
            return this.GetStringFormat(StatManager.GetValue("DCGlobalPlayedChallenges"));
        };

        SolitaireStatistics.prototype.GetDCDaysCompletedFormatString = function () {
            return this.GetStringFormat(StatManager.GetValue("DCGlobalDaysCompleted"));
        };

        SolitaireStatistics.prototype.GetDCBronzeBadgesWonFormatString = function () {
            return this.GetStringFormat(StatManager.GetValue("DCGlobalBronzeBadgesWon"));
        };

        SolitaireStatistics.prototype.GetDCSilverBadgesWonFormatString = function () {
            return this.GetStringFormat(StatManager.GetValue("DCGlobalSilverBadgesWon"));
        };

        SolitaireStatistics.prototype.GetDCGoldBadgesWonFormatString = function () {
            return this.GetStringFormat(StatManager.GetValue("DCGlobalGoldBadgesWon"));
        };

        SolitaireStatistics.prototype.GetDCDiamondBadgesWonFormatString = function () {
            return this.GetStringFormat(StatManager.GetValue("DCGlobalDiamondBadgesWon"));
        };

        SolitaireStatistics.prototype.GetDCPerfectCompletionsFormatString = function () {
            return this.GetStringFormat(StatManager.GetValue("DCGlobalPerfectCompletions"));
        };

        // SC
        SolitaireStatistics.prototype.GetSCTotalStarsEarnedFormatString = function () {
            return this.GetStringFormat(StatManager.GetValue("SCGlobalStarsEarned"));
        };

        SolitaireStatistics.prototype.GetSCChallengesCompletedFormatString = function () {
            return this.GetStringFormat(StatManager.GetValue("SCGlobalChallengesCompleted"));
        };

        SolitaireStatistics.prototype.GetSCPacksUnlockedFormatString = function () {
            return this.GetStringFormat(StatManager.GetValue("SCGlobalPacksUnlocked"));
        };

        SolitaireStatistics.prototype.GetSCCollectionsUnlockedFormatString = function () {
            return this.GetStringFormat(StatManager.GetValue("SCGlobalCollectionsUnlocked"));
        };

        SolitaireStatistics.prototype.GetSCCrownsEarnedFormatString = function () {
            return this.GetStringFormat(StatManager.GetValue("SCGlobalCrownsEarned"));
        };

        SolitaireStatistics.prototype.GetSCCompletionPercentageFormatString = function () {
            var percentage = this.GetPercentage(StatManager.GetValue("SCGlobalChallengesCompleted"), StatManager.GetValue("SCGlobalTotalChallenges"));

            return Math.floor(100 * percentage) + "%";
        };

//#endregion

        return SolitaireStatistics;

    });

